export default __webpack_public_path__ + "static/media/berlin_impfbaer_light.6236dd9f.png";